import EF from 'ef/ef';
import ContentProvider from 'services/content-provider';

const SurveyService = {
  initialize: function (mapping) {
    mapping = mapping || {};
    this.mapping = mapping;
    this.ContentProvider = ContentProvider;
  },

  surveyUrl: function (courseSlug, returnHash) {
    const settings = this.mapping[courseSlug];
    if (!settings) {
      console.warn('Invalid survey mapping for slug: ', courseSlug);
      console.warn('Here are the survey mappings for reference: ', this.mapping);
      // trigger something special...
      return null;
    }
    //var redirectPath = window.location.pathname + "#" + EF.module.currentActivity.currentPage.path();
    let hash = returnHash || window.location.hash;
    if (!returnHash && EF.module && EF.module.currentActivity && EF.module.currentActivity.currentPage) {
      hash = `#${EF.module.currentActivity.currentPage.path()}`;
    }

    const redirectPath = window.location.pathname + window.location.search + hash;
    let url = '/student/redirect_to_survey?survey_id=:survey_id&module_redirect_url=:redirect_url';
    url = url.replace(':survey_id', settings.survey_id);
    url = url.replace(':redirect_url', encodeURIComponent(redirectPath));
    return url;
  },

  userHasCompletedSurvey: function (courseSlug) {
    return this.ContentProvider.SurveyService.userHasCompletedSurvey(courseSlug);
  },

  getActivityProgressForSlug: function (courseSlug) {
    const settings = this.mapping[courseSlug];
    return EF.activityProgresses.find(function (ap) {
      if (EF.options.local) {
        return ap.get('slug') === courseSlug;
      } else {
        return ap.get('activity_id') === settings.id;
      }
    });
  },
};

export default SurveyService;
